"use strict";

exports.__esModule = true;
var _TicketTypeEditor = require("./TicketTypeEditor");
Object.keys(_TicketTypeEditor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketTypeEditor[key]) return;
  exports[key] = _TicketTypeEditor[key];
});